import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { pathOr } from '../../../../../helpers/ramda';
import { api } from '../../../../../api/requestor';
import { INSURANCES_NOT_RETURNED_BECAUSE_TOO_LATE } from '../../../../constants/errors';
import { INSURANCE_REFUND_PROCESS, getIsInsuranceRefunding, addRefundingInsurance } from './helper';
import OrderInsurance from './OrderInsurance';
import { isDefaultAccountSpa, orderParams } from '../../../helpers';
const ERROR_TEXT = I18n.t('components.OrderInsurance.error') || {};
class OrderInsuranceContainer extends PureComponent {
  static propTypes = {
    orderId: PropTypes.string.isRequired,
    insurance: PropTypes.object.isRequired,
    downloadInsurancesPath: PropTypes.string
  };
  state = {
    isRefunding: false,
    refundStatus: null,
    errorText: null
  };
  UNSAFE_componentWillMount() {
    const {
      orderId
    } = this.props;
    this.setState({
      refundStatus: getIsInsuranceRefunding(orderId) ? INSURANCE_REFUND_PROCESS : null
    });
  }
  onRefund = () => {
    const {
      orderId
    } = this.props;
    this.setState({
      isRefunding: true
    });
    api.post.account.returnInsurances(orderId, orderParams).then(({
      errors
    }) => {
      if (errors) {
        const errorCode = pathOr('', ['0', 'code', errors]);
        const lowerErrorCode = errorCode.toLowerCase();
        const errorKey = lowerErrorCode in ERROR_TEXT ? lowerErrorCode : 'common';
        this.setState({
          errorText: I18n.t(`components.OrderInsurance.error.${errorKey}`),
          isRefunding: false,
          isRetriable: errorCode !== INSURANCES_NOT_RETURNED_BECAUSE_TOO_LATE
        });
        return;
      }
      this.setState({
        errorText: null,
        refundStatus: INSURANCE_REFUND_PROCESS
      });
      addRefundingInsurance(orderId);
    });
  };
  render() {
    const {
      isRefunding,
      refundStatus,
      errorText,
      isRetriable
    } = this.state;
    return /*#__PURE__*/React.createElement(OrderInsurance, {
      ...this.props,
      isRefunding: isRefunding,
      refundStatus: refundStatus,
      errorText: errorText,
      isRetriable: isRetriable,
      onRefund: this.onRefund,
      isDownloadButtonShown: isDefaultAccountSpa
    });
  }
}
export default OrderInsuranceContainer;